module.exports = __webpack_public_path__ + "static/media/LV.27c0947d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/LV.svg
// module id = 246
// module chunks = 0